import React, { createContext, FC } from 'react'

export interface DomainProviderContextValue {
    currentContext?: string
    admin?: string
    jhire?: string
    forum?: string
    source?: string
    jobSeeker?: string
    logoUrl?: string
    rtmpUrl?: string
    video?: string
    actuateIPortal?: string
    analytics?: string
    cdn?: string
}

export const DomainContext = createContext<DomainProviderContextValue>({})

const { Provider, Consumer } = DomainContext

export interface DomainProviderProps {
    urls: DomainProviderContextValue
}
export const DomainProvider: FC<DomainProviderProps> = ({ urls, children }) => (
    <Provider value={urls}>
        {children}
    </Provider>
)

export default DomainProvider
